import Card from './Card';

export interface EducationProps {
    eduYear: string;
    title: string;
    school: string;
    schoolURL: string;
    moreInfos: Array<string>;
    schoolLogo?: string;
}

const Education = (props: EducationProps) => {
    const infoText = props.moreInfos.join(' • ');

    return (
        <Card
            icon={
                props.schoolLogo ? (
                    <img src={props.schoolLogo} alt={props.school} className="school-logo" />
                ) : (
                    <i className="icon bi-asterisk"></i>
                )
            }
        >
            <h4 className="title">
                {props.title}
                <br />
                <a href={props.schoolURL}>{props.school}</a>
            </h4>
            <p className="description m-0">
                <strong>{props.eduYear}</strong>
                <br />
                <br />
                {infoText}
            </p>
        </Card>
    );
};

export default Education;
